import { d as dev } from "../../../chunks/index5.js";
async function load({ request }) {
  const server = request.headers.get("x-gradio-server") || "http://127.0.0.1:7860";
  const port = request.headers.get("x-gradio-port") || "7860";
  const local_dev_mode = request.headers.get("x-gradio-local-dev-mode") || dev ? "true" : void 0;
  return {
    server,
    port,
    local_dev_mode
  };
}
export {
  load
};
